export default __webpack_public_path__ + "static/media/vid6.018e39db.mp4";